import { createContext, useContext } from 'react';
import Theme from '../model/Theme';

/**
 * Designed to provide a single `Theme` record to internal UI components.
 */
const ThemeContext = /*#__PURE__*/createContext(Theme());
export const useTheme = () => useContext(ThemeContext);
export default ThemeContext;